import { connect } from 'react-redux';

import { lowInventoryProductsCount } from '../selectors';

const withLowInventoryProductsCount = connect(state => ({
  lowInventoryProductsCount: lowInventoryProductsCount(state),
}));

export default withLowInventoryProductsCount;
